import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { SeoJournal } from "@/components/site/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Journal() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/articles`)
      .then((r) => setArticles(r.data))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#f7f5f0] text-[#1a1918]" data-testid="journal-page">
      <SeoJournal />
      <header className="border-b border-[#1a1918]/15">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
          <Link to="/" className="font-serif-ed text-xl md:text-2xl">
            ProSecours
          </Link>
          <Link to="/" className="overline text-[#1a1918]/70 hover:text-[#1a1918]">
            ← Retour à l'accueil
          </Link>
        </div>
      </header>

      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 md:py-28">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          className="grid grid-cols-12 mb-16"
        >
          <div className="col-span-12 md:col-span-3">
            <span className="overline text-[#1a1918]/60">§ Journal</span>
          </div>
          <div className="col-span-12 md:col-span-8 md:col-start-4 mt-4 md:mt-0">
            <h1 className="font-serif-ed text-5xl md:text-7xl leading-[1] tracking-tight">
              Notes de <span className="italic text-[#ce1e20]">restructuration</span>.
            </h1>
            <p className="mt-8 text-base md:text-lg text-[#1a1918]/75 max-w-2xl">
              Des repères clairs pour comprendre les formalités juridiques et
              les procédures collectives, sans jargon inutile. Publications régulières.
            </p>
          </div>
        </motion.div>

        <div className="border-t border-[#1a1918]/25">
          {loading && (
            <div className="py-16 text-center text-[#1a1918]/60 font-serif-ed italic text-2xl">
              Chargement des articles…
            </div>
          )}
          {!loading && articles.length === 0 && (
            <div className="py-16 text-center text-[#1a1918]/60 font-serif-ed italic text-2xl">
              Aucun article pour le moment.
            </div>
          )}
          {articles.map((a, i) => (
            <motion.article
              key={a.slug}
              data-testid={`journal-item-${a.slug}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.05 }}
              className="border-b border-[#1a1918]/25 py-10 md:py-14"
            >
              <Link
                to={`/journal/${a.slug}`}
                className="grid grid-cols-12 gap-4 group"
              >
                <div className="col-span-12 md:col-span-2 overline text-[#1a1918]/60">
                  {a.date}
                </div>
                <div className="col-span-12 md:col-span-8">
                  <div className="overline text-[#ce1e20]">{a.tag}</div>
                  <h2 className="mt-3 font-serif-ed text-3xl md:text-5xl leading-tight tracking-tight text-[#1a1918] group-hover:text-[#ce1e20] transition-colors duration-300">
                    {a.title}
                  </h2>
                  <p className="mt-4 text-base md:text-lg text-[#1a1918]/75 max-w-2xl">
                    {a.excerpt}
                  </p>
                </div>
                <div className="col-span-12 md:col-span-2 md:text-right overline text-[#1a1918]/60 self-end">
                  {a.readTime} · Lire →
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>

      <footer className="border-t border-[#1a1918]/15 py-8">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 overline text-[#1a1918]/50">
          © MMXXV ProSecours
        </div>
      </footer>
    </div>
  );
}
